export default{
    namespaced: true,

    state:{
        fecha:null,
        vista:'month',
        medico:null,
        eventos:[],
    },
    mutations:{
        CAMBIA_FECHA(state, data){
            //console.log(data.root)
            state.fecha = data
        },
        CAMBIA_VISTA(state, data){
            state.vista = data
        },
        CAMBIA_MEDICO(state, data){
            state.medico = data
        },
        CAMBIA_EVENTOS(state, data){
            state.eventos = data
        },


    },
    actions:{
        //
    },
    getters:{
        //
    },
}